export default __webpack_public_path__ + "static/media/dumbbells-set.bcf9cc21.jpg";